




































import Component from 'vue-class-component';
import Vue from 'vue';
import {FilterItem, State, Styles} from "../store";
import {isEmpty, logger} from "../../plagins/utils";
import {trans} from "../../plagins/translate";

@Component
export default class FiltersVue extends Vue {

    state: State | any;
    styles: Styles | any = {};

    is_selected: boolean = false;

    selectFilter(filter_item: FilterItem) {
        this.is_selected = true;
    }

    clearFilter() {
        this.is_selected = false;
        this.$store.commit('clean_values_in_list_for_filter');
        this.$store.commit('apply_filter');
    }


    isEmpty(value: any): boolean {
        return isEmpty(value);
    }

    // isValid(kt_setting: KtSetting) {
    //     return !isEmpty(kt_setting.drop_down) && kt_setting.name !== 'dist'
    // }


    trans(s: string): string {
        return trans(s);
    }

    mounted(): void {
    }

    created(): void {
        this.state = this.$store.state;
        this.styles = this.$store.state.remote_data.styles;
    }

}
